import a from "./generateUtilityClasses.mjs";
import r from "./generateUtilityClass.mjs";
const s = (e) => r("MuiPickersCalendarHeader", e), l = a("MuiPickersCalendarHeader", ["root", "labelContainer", "label", "switchViewButton", "switchViewIcon"]);
export {
  s as getPickersCalendarHeaderUtilityClass,
  l as pickersCalendarHeaderClasses
};
//# sourceMappingURL=pickersCalendarHeaderClasses.mjs.map
